import React from 'react';
import { Route, IndexRoute } from 'react-router';
import URLHelpers from '../components/shared/url_helpers';

const ConvertShopTypeRoute = (
  <Route
    key={URLHelpers.convertShopTypePath}
    path={URLHelpers.convertShopTypePath}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../onboarding/legacy/convert_shop_type_container').default);
        },
        'onboarding',
      );
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../onboarding/legacy/convert_shop_type_form').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={URLHelpers.convertShopTypeFinishPath}
      path={URLHelpers.convertShopTypeFinishPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../onboarding/legacy/convert_shop_type_complete').default);
          },
          'onboarding',
        );
      }}
    />
  </Route>
);

export default ConvertShopTypeRoute;
